import { Dropdown } from 'react-bootstrap';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { FILTER_KEYS, NO_ZONE, TIME_SINCE_ZONE_TYPES } from '../../../../config/constants';
import { routeToSpecificScope } from '../../../../helpers';
import { useFiltersDispatch, useFiltersState } from '../../../../store/hooks';
import { TimeSinceFilterPropsType } from './types';

export const TimeSinceFilter = ({ forceScope, show, customView, close, open, loadData }: TimeSinceFilterPropsType) => {
  
  const { pathname } = useLocation();
  const specificScope = forceScope || routeToSpecificScope(pathname);
  const {
    [FILTER_KEYS.TIME_SINCE_MAX]: timeSinceMaxState = {
      zone: {
        value: -1,
        name: NO_ZONE
      },
      percentage: -1
    }
  } = useFiltersState(specificScope, FILTER_KEYS.TIME_SINCE_MAX);
  const {
    zone = {
      value: -1,
      name: NO_ZONE
    },
    percentage = -1
  } = timeSinceMaxState;
  const { changeFilterData } = useFiltersDispatch();
  const [appliqued, setAppliqued] = useState(false);
  const [selectedZone, setSelectedZone] = useState(zone);
  const [selectedPercentage, setSelectedPercentage] = useState(percentage);
  
  const groupValues = [[30, 35, 40, 45, 50], [60, 65, 70, 75, 80]];
  const radios: [JSX.Element[], JSX.Element[]] = [[], []];
  groupValues.forEach((values, indexGroup) => {
    values.forEach((value, index) => {
      radios[indexGroup].push(
        <li key={index + value}>
          <div className="radio">
            <input
              onChange={() => {
                setSelectedPercentage(value);
                setSelectedZone({ value: -1, name: '' });
              }}
              id={`radio-${value}%`}
              name="radio"
              type="radio"
              value={value}
              checked={value === selectedPercentage}
            />
            <label
              htmlFor={`radio-${value}%`}
              style={{ fontWeight: value === selectedPercentage ? 'bold' : undefined }}
              className="radio-label"
            >
              {value + '%'}
            </label>
          </div>
        </li>
      );
    });
  });
  const liZones: JSX.Element[] = [];
  TIME_SINCE_ZONE_TYPES.forEach((type, index) => {
    liZones.push(
      <li key={index + type.value}>
        <div className="radio">
          <input
            id={`radio-${type.value}`}
            onChange={() => {
              setSelectedZone(type);
              setSelectedPercentage(-1);
            }}
            name="radio"
            type="radio"
            value={type.value}
            checked={JSON.stringify(type) === JSON.stringify(selectedZone)}
          />
          <label
            htmlFor={`radio-${type.value}`}
            style={{ fontWeight: JSON.stringify(type) === JSON.stringify(selectedZone) ? 'bold' : undefined }}
            className="radio-label"
          >
            {type.name}
          </label>
        </div>
      </li>
    );
  });
  
  return (
    <Dropdown className="btn-max a-right" show={show} onToggle={show ? close : open}>
      <Dropdown.Toggle id="dropdown-basic" className="btn-border btn-timex" disabled={customView}>
        <label className={appliqued ? 'appliqued' : ''}>TIME SINCE X% OF MAX</label>
        {zone && zone.value !== -1 ? zone.name :
          percentage !== -1 ? percentage + '%' :
            'Select a Time'}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div className="max-body">
          <div className="max-t"> BY ZONE</div>
          <form>
            <ul> {liZones} </ul>
          </form>
          <div className="max-t">BY % OF MAX</div>
          <form>
            <div className="max-b">
              <div className="max-b-1">
                <ul> {radios[0]} </ul>
              </div>
              <div className="max-b-2">
                <ul> {radios[1]} </ul>
              </div>
            </div>
          </form>
        </div>
        <div className="footer-s">
          <button
            className="btn-transparet"
            onClick={() => {
              close();
              setSelectedZone(zone);
              setSelectedPercentage(percentage);
            }}
          >
            Cancel
          </button>
          <button
            className="btn-blue"
            onClick={() => {
              close();
              setAppliqued(true);
              changeFilterData({
                zone: selectedZone,
                percentage: selectedPercentage
              }, FILTER_KEYS.TIME_SINCE_MAX, specificScope)();
              loadData();
            }}
          >
            Apply
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TimeSinceFilter;
export * from './types';
